<template>
  <div class="design-row-cell">Platform</div>
</template>

<script>
// PLATFORM
export default {
  name: 'SlotTableCell'
}
</script>
